<template>
  <div>
    <div class="image">
      <img src="../../assets/img/success.png" alt="" />
    </div>
    <p>操作成功</p>
    <div class="sures">
      <button @click="determine" class="but-sty">确定</button>
    </div>
  </div>
</template>

<script>
export default {
    created(){
      document.title="成功"
    },
    methods: {
        determine(){ 
					var u = navigator.userAgent;
    			var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
					var isIOS = u.indexOf("iPhone") > -1 || u.indexOf("iOS") > -1; //ios终端
						if(isAndroid){
							window.JSView.callback();
						}else if(isIOS){
              var dict = {
                "name":"LiBaoQin",
                "gender":"Boy"
              };             
							window.webkit.messageHandlers.back.postMessage(dict);
						}
        }
    },
};
</script>

<style scoped>
.image{
    text-align: center;
    margin-top: 100px;
    vertical-align: middle;
}
p{
    text-align: center;
    margin-top: 20px;
    font-size: 14px;
    color: #666;
}
.sures{
    text-align: center;
    margin-top: 80px
}
.but-sty{
    width: 150px;
    height: 44px;
    background: #FF615C;
    color: #fff;
    border: none;
    font-size: 14px;
    display: inline-block;
    white-space: nowrap;
    -webkit-appearance: none;
    text-align: center;
    font-weight: 500;
    border-radius: 4px;
}
</style>
